import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { AppShell } from "@/components/app-shell";
import { requireRole } from "@/lib/session";
import { supabase } from "@/integrations/supabase/client";
import { LearnerFeesView } from "@/components/fees/fee-shared";

export const Route = createFileRoute("/learner/fees")({
  ssr: false,
  beforeLoad: () => requireRole("learner"),
  head: () => ({ meta: [{ title: "My Fees — MAKAI" }] }),
  component: LearnerFeesPage,
});

function LearnerFeesPage() {
  const [learners, setLearners] = useState<any[]>([]);
  const [currency, setCurrency] = useState("UGX");

  useEffect(() => {
    (async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;
      const { data: ls } = await supabase.from("learners").select("id,first_name,last_name,school_id,admission_number").eq("user_id", user.id);
      setLearners(ls ?? []);
      if (ls && ls.length > 0 && ls[0].school_id) {
        const { data: school } = await supabase.from("schools").select("currency").eq("id", ls[0].school_id).maybeSingle();
        if (school?.currency) setCurrency(school.currency);
      }
    })();
  }, []);

  return (
    <AppShell role="learner" title="My fees" subtitle="See what is owed and pay via MTN, Airtel, card or bank — the school confirms each payment.">
      {learners.length === 0
        ? <div className="rounded-2xl border border-dashed border-border p-8 text-center text-sm text-muted-foreground">Your account is not linked to a school learner profile yet. Ask your school admin to enroll you.</div>
        : <LearnerFeesView learners={learners} schoolCurrency={currency} />}
    </AppShell>
  );
}
